import { Link, Outlet } from 'react-router-dom';

import { useAuthStore } from '../stores/authStore.js';

import { BottomNav } from './BottomNav.js';
import { TrialNotice } from './TrialNotice.js';
import { WeightPromptGate } from './WeightPromptGate.js';

export function Layout() {
  const isAdmin = useAuthStore((state) => state.user?.role === 'ADMIN');
  return (
    <>
      <header className="app-header">
        <div className="header-content">
          <span className="logo">OnFlow</span>
          {isAdmin && (
            <Link to="/admin" className="admin-entry-link">
              Control room
            </Link>
          )}
        </div>
      </header>
      <div className="app-notice-slot">
        <TrialNotice />
      </div>
      <main className="app-content">
        <div className="view-container">
          <Outlet />
        </div>
      </main>
      <BottomNav />
      <WeightPromptGate />
    </>
  );
}
